import axios from 'axios'
import cookie from "cookie.js";
// const baseURL = 'http://192.168.1.80:8090'
const baseURL = 'https://www.jiuselu.net/prod-api'

export const http = axios.create({
    baseURL,
    timeout: 5000,
    headers: {
      'tenant-id': 1
    }
})

// 获取banner列表
export const getBannerList = (id) => {
  return http.post('/pc/banner/getBannerList', {
    columnId: id,
    limit: 9999,
    page: 1,
  })
}

// 获取作品推荐列表
export const getWorksList = (type) => {
  return http.get(`/pc/opus/home/list?page=1&limit=8&opusType=${type}&time=1&status=1`, {
  })
}

// 获取艺术鉴赏列表
export const getNewsList = (type, size = 4) => {
  return http.get(`pc/appreciation/home/list?page=1&limit=${size}&status=1&type=${type}&time=1`, {
  })
}

// 获取艺术鉴赏详情
export const getNewsDetail = (id) => {
  return http.get(`pc/appreciation/home/${id}`)
}

// 点赞
export const likeNews = (id, isLike) => {
  return http.post(`pc/appreciation/dealLikes?artId=${id}&isLike=${isLike}`)
}

// 获取艺术家列表
export const getArtistList = (pageNum, pageSize) => {
  return http.get(`pc/artist/home/list?page=${pageNum}&limit=${pageSize}&isRecommended=0&isHot=0`)
}

// 获取推荐艺术家
export const getRecommendArtistList = (pageSize, isHot = 1, isRecommended = 1) => {
  return http.get(`pc/artist/home/list?page=1&limit=${pageSize}&isRecommended=${isRecommended}&isHot=${isHot}`)
}

// 获取艺术家详情
export const getArtistDetail = (id) => {
  return http.get(`pc/artist/home/${id}`)
}

// 首字母
export const getArtistByLetter = (letter) => {
  return http.get(`pc/artist/listByLetter?letter=${letter}`)
}

// 新增用户反馈
export const addFeedback = (data) => {
  return http.post('/system/feedback', data)
}

// 查询网站设置
export const getWebsiteSetting = () => {
  return http.get('/pc/websiteSettings/selectWebsiteSettings?websiteId=10000034')
}

// 获取文章相关模型
export const getArticleRelatedModel = (id) => {
  return http.get(`/app-api/promotion/article/get?id=${id}`)
}

// 获取模型相关文章
export const getModelRelatedArticle = (modelId) => {
  return http.get(`/pc/appreciation/getArtAppreciationByModelId?modelId=${modelId}&page=1&limit=4`)
}

// 帮助中心
export const getHelpCenterList = () => {
  return http.get('/app-api/member/help-center/typeList')
}

// 根据名称获取帮助中心
export const getHelpCenterByName = (name) => {
  return http.get(`/app-api/member/help-center/listByName?name=${name}`)
}

// 跳转到虚拟展馆
export const toVirtualHall = (id = 13) => {
  // return http.get('/app-api/member/help-center/typeList')
  window.open(`http://www.bolanzg.com/preview?id=${id}`, '_blank')
}
